module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti-2f016cd9f3f971b5c8cc843b4abb20ae.jpg";